import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconGrid: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="grid, camera-grid"><path d="M8.5 3.75V20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M15.5 3.75V20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 8.5H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 15.5H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconGrid;
